(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name crewPunctualityReport.controller:CrewPunctualityReportCtrl
   *
   * @description
   *
   */
  angular
    .module('crewPunctualityReport')
    .controller('CrewPunctualityReportCtrl', CrewPunctualityReportCtrl);

  function CrewPunctualityReportCtrl(CommonMasterData, $sce, crewScheduleService, CommonLogicService) {
    var vm = this;
    vm.ctrlName = 'CrewPunctualityReportCtrl';
    vm.reportTypes = {
      DAILY : 'DAILY',
      WEEKLY : 'WEEKLY',
      MONTHLY : 'MONTHLY'
    }
    vm.model = {
      searchPanelToggle: true,
      searchCriteria: {
        fromDate: null,
        toDate: null,
        reportType: null,
        crewType: null,
        crewId: null
      },
      masterList: {
        crewTypes: [],
        fromTimeInvalid: false,
        toTimeInvalid: false
      },
      initialSearchDone: false,
      reportDataURL: null,
      reportServerBaseUrl: null
    };

    // toggle search
    vm.clickOnSearch = function () {
      vm.model.searchPanelToggle = !vm.model.searchPanelToggle;
      vm.model.initialSearchDone = false;
    };

    // submit search
    vm.submitSearch = function (params) {
      searchPunctualityReport(params);
    };

    function searchPunctualityReport(param) {
      vm.model.initialSearchDone = true;
      if (isValidSearchParams(param)) {
        vm.model.searchCriteria = param;
        vm.model.searchPanelToggle = false;

        var rptDesign = "crew_punctuality_report.rptdesign";


        var url = CommonLogicService.getReportUrl(rptDesign, getSearchParamMap(param));
        vm.model.reportDataURL = $sce.trustAsResourceUrl(url);
      }
    }

    function isValidSearchParams(params) {
      setDateValidationFlags();
      if ((!!vm.model.searchCriteria.fromDate && !vm.model.masterList.fromTimeInvalid) &&
        (!!vm.model.searchCriteria.toDate && !vm.model.masterList.toTimeInvalid)
        && (!!vm.model.searchCriteria.crewId || !!vm.model.searchCriteria.crewType)) {
        return true;
      }
      return false;
    }

    function setDateValidationFlags() {
      //if from date invalid
      if (isDateFormatInvalid(vm.model.searchCriteria.fromDate)) {
        vm.model.masterList.fromTimeInvalid = true;
      } else {
        vm.model.masterList.fromTimeInvalid = false;
      }
      if (isDateFormatInvalid(vm.model.searchCriteria.toDate)) {
        vm.model.masterList.toTimeInvalid = true;
      } else {
        vm.model.masterList.toTimeInvalid = false;
      }

    }

    function isDateFormatInvalid(date) {
      if (!!date && !moment(date, "DD/MM/YYYY").isValid()) {
        return true;
      }
      return false;
    }

    vm.loadCrewID = function () {
      vm.model.searchCriteria.crewId = vm.model.searchCriteria.crew.crewId;
    };

    function getReportType(reportType){
      if(reportType === null ){
        return vm.reportTypes.DAILY;
      }else if(reportType){
        return vm.reportTypes.WEEKLY;
      }else{
        return vm.reportTypes.MONTHLY;
      }
    }

    function getSearchParamMap(param) {
      var searchParamMap = {};
      searchParamMap["fromDate"] = param.fromDate;
      searchParamMap["toDate"] = param.toDate;
      if(!!param.crewType && !!param.crewType.crewTypeCode){
        searchParamMap["crewTypeCode"] = param.crewType.crewTypeCode;
      }
      if(!!param.crewId) {
        searchParamMap["crewId"] = param.crewId;
      }
      searchParamMap["referrer"] = window.location.origin;

      searchParamMap["reportType"] = getReportType(param.reportType);
      return searchParamMap;
    }

    vm.changeSearchField = function (searchCriteria, flag) {
      if (flag == 'crewType') {
        vm.model.searchCriteria.crewId = '';
        if (vm.model.searchCriteria.crewType == null) {
          vm.model.masterList.crewList = [];
        }else{
          vm.model.searchCriteria.crewId = '';
        }
      } else if (flag == 'crewId') {
        vm.model.searchCriteria.crewType = null;
      }

    };
    (function loadCrewTypes() {
      CommonMasterData.getCrewTypeList(
        function (crewTypes) {
          vm.model.masterList.crewTypes = crewTypes;
          // vm.model.masterList.msgRecipients = crewTypes;
        },
        function () {
          console.log('Crew type retrieval error');
        }
      );
    })();
  }
}());
